import React from "react";
import img2 from "../images/homepage/2.png";
import img3 from "../images/homepage/3.png";
import img4 from "../images/homepage/4.png";
import img5 from "../images/homepage/5.png";
import img6 from "../images/homepage/6.png";
import img7 from "../images/homepage/7.png";
import img8 from "../images/homepage/8.png";
import img9 from "../images/homepage/9.png";

export default function Benefits() {
  const images = [img2, img3, img4, img5, img6, img7, img8, img9];

  return (
    <div className="benefits-section">
      <h2>Our Exclusive Collection</h2>
      <div className="benefits-grid-container">
        {images.map((img, index) => (
          <div key={index} className="benefit-card">
            <div className="benefit-image-box">
              <img src={img} alt={`Benefit ${index + 1}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
